/**
 * User-facing copy for the offer launch links (hubspot-off-block-3 task 98).
 * This repo has no i18n framework yet, so the copy lives here instead of
 * inline in the components.
 */
export const launchOfferStrings = {
  noLinkRetiredCheckout: "No link: retired checkout",
  retiredCheckoutHint:
    "This offer used the retired Chargify checkout (/onboard/place-order), which now redirects to the pricing page. Only ClickFunnels and product-catalog offers have a sales or UTM link.",
};
